export default __webpack_public_path__ + "static/media/yellow-ball-inverted.5702c8d1.svg";